module.exports = __webpack_public_path__ + "47c17e5eb3324118a3e8a2fbf2a56fce.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture-1024.jpg
// module id = 404
// module chunks = 0